import React, { useState } from 'react';
import UPPage from '../components/UPPage';
import RegistrationForm from '../components/RegistrationForm';

import useProxyAuth from '../hooks/useProxyAuth';
import { LinearProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Registration page
 */
export default function() {
  const { isLogged } = useProxyAuth();
  const { t } = useTranslation();
  const [success, setSuccess] = useState(false);

  if (isLogged || isLogged === undefined) {
    return <LinearProgress color="primary" />;
  }

  return (
    <UPPage>
      {!success && <RegistrationForm setSuccess={setSuccess} />}
      {success && (
        <Typography variant="body1">{t('successMessage')}</Typography>
      )}
    </UPPage>
  );
}
